/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';

import { IPromoContainerItemProps, IPromoContainerViewProps } from './promo-container';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

const ItemComponent: React.FC<IPromoContainerItemProps> = ({ itemProps, item }) => (
    <>
        <Node {...itemProps}>{item}</Node>
    </>
);

export default (props: IPromoContainerViewProps) => {
    const { items, promoContainerModuleProps } = props;

    return (
        <Module {...promoContainerModuleProps}>
            {items.map(item => (
                <ItemComponent key={item.id} {...item} />
            ))}
        </Module>
    );
};
